(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["4one-featured-roasters"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('four-one-roaster-slider')) {
  customElements.define('four-one-roaster-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.four-one-roasters__grid');
      this.controls = this.querySelector('.four-one-roasters__controls');
      this.progressTrack = this.querySelector('[data-progress-track]');
      this.progressThumb = this.querySelector('[data-progress-thumb]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');

      if (!this.track || !this.controls || !this.progressThumb || !this.prev || !this.next) return;

      this.abort = new AbortController();
      const options = { signal: this.abort.signal };

      this.getMetrics = () => {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.min(maximum, Math.abs(this.track.scrollLeft));
        const ratio = maximum > 0 ? position / maximum : 0;
        const visibleRatio = this.track.scrollWidth > 0
          ? Math.min(1, this.track.clientWidth / this.track.scrollWidth)
          : 1;

        return { maximum, position, ratio, visibleRatio };
      };

      this.update = () => {
        const { maximum, position, ratio, visibleRatio } = this.getMetrics();
        const thumbWidth = Math.max(8, visibleRatio * 100);
        const thumbLeft = ratio * Math.max(0, 100 - thumbWidth);

        this.controls.hidden = maximum <= 2;
        this.prev.disabled = position <= 2;
        this.next.disabled = position >= maximum - 2;

        this.progressThumb.style.width = `${thumbWidth}%`;
        this.progressThumb.style.left = `${thumbLeft}%`;
      };

      this.move = (direction) => {
        const card = this.track.querySelector('.four-one-roasters__item');
        if (!card) return;

        const style = getComputedStyle(this.track);
        const gap = parseFloat(style.columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const rtlMultiplier = style.direction === 'rtl' ? -1 : 1;

        this.track.scrollBy({
          left: direction * rtlMultiplier * step,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };

      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);

      this.track.addEventListener('scroll', this.update, { ...options, passive: true });

      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

        event.preventDefault();
        const rtlMultiplier = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.move((event.key === 'ArrowRight' ? 1 : -1) * rtlMultiplier);
      }, options);

      if (this.progressTrack) {
        this.progressTrack.addEventListener('click', (event) => {
          const { maximum, visibleRatio } = this.getMetrics();
          if (maximum <= 0) return;

          const rect = this.progressTrack.getBoundingClientRect();
          const clickRatio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
          const thumbRatio = Math.min(1, Math.max(0.08, visibleRatio));
          const travelRatio = Math.max(0.0001, 1 - thumbRatio);
          const targetRatio = Math.min(1, Math.max(0, (clickRatio - thumbRatio / 2) / travelRatio));
          const rtlMultiplier = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;

          this.track.scrollTo({
            left: targetRatio * maximum * rtlMultiplier,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }, options);
      }

      document.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('.four-one-roasters__item');
        if (item && this.contains(item)) {
          item.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
        }
      }, options);

      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);

      this.update();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["four-one-trust-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('four-one-trust-reveal')) {
    customElements.define('four-one-trust-reveal', class extends HTMLElement {
      connectedCallback() {
        if (this.played || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.played = true;
          this.classList.add('is-revealing');
          this.observer.disconnect();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
